import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { SUPPORTED, FALLBACK } from "./languages";

import enCommon from "../locales/en/common.json";
import enLanding from "../locales/en/landing.json";
import enPrivacy from "../locales/en/privacy.json";
import enAuth from "../locales/en/auth.json";
import enDashboard from "../locales/en/dashboard.json";
import frCommon from "../locales/fr/common.json";
import frLanding from "../locales/fr/landing.json";
import frPrivacy from "../locales/fr/privacy.json";
import frAuth from "../locales/fr/auth.json";
import frDashboard from "../locales/fr/dashboard.json";
import esCommon from "../locales/es/common.json";
import esLanding from "../locales/es/landing.json";
import esPrivacy from "../locales/es/privacy.json";
import esAuth from "../locales/es/auth.json";
import esDashboard from "../locales/es/dashboard.json";
import deCommon from "../locales/de/common.json";
import deLanding from "../locales/de/landing.json";
import dePrivacy from "../locales/de/privacy.json";
import deAuth from "../locales/de/auth.json";
import deDashboard from "../locales/de/dashboard.json";
import itCommon from "../locales/it/common.json";
import itLanding from "../locales/it/landing.json";
import itPrivacy from "../locales/it/privacy.json";
import itAuth from "../locales/it/auth.json";
import itDashboard from "../locales/it/dashboard.json";

const resources = {
  en: { common: enCommon, landing: enLanding, privacy: enPrivacy, auth: enAuth, dashboard: enDashboard },
  fr: { common: frCommon, landing: frLanding, privacy: frPrivacy, auth: frAuth, dashboard: frDashboard },
  es: { common: esCommon, landing: esLanding, privacy: esPrivacy, auth: esAuth, dashboard: esDashboard },
  de: { common: deCommon, landing: deLanding, privacy: dePrivacy, auth: deAuth, dashboard: deDashboard },
  it: { common: itCommon, landing: itLanding, privacy: itPrivacy, auth: itAuth, dashboard: itDashboard },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: SUPPORTED,
    fallbackLng: FALLBACK,
    load: "languageOnly", // fr-CA -> fr
    ns: ["common", "landing", "privacy", "auth", "dashboard"],
    defaultNS: "common",
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    returnNull: false,
  });

const applyHtmlLang = (lng) => {
  document.documentElement.lang = (lng || FALLBACK).split("-")[0];
};
applyHtmlLang(i18n.language);
i18n.on("languageChanged", applyHtmlLang);

export default i18n;
